import { ITemplateVariable } from "./template";

interface TemplateSendPayload {
  to: string;
  templateName: string;
  language: string;
  parameterFormat: "POSITIONAL" | "NAMED";
  variables: Record<string, string>;
}

export function extractTemplateVariables(template: any): ITemplateVariable[] {
  const body = template.components?.find((c: any) => c.type === "BODY");
  if (!body?.text) return [];

  // 🟢 POSITIONAL → {{1}}, {{2}}
  if (template.parameter_format === "POSITIONAL") {
    const matches = body.text.match(/{{\d+}}/g) ?? [];

    const uniques = matches.filter(
      (v: string, i: number, arr: string[]) => arr.indexOf(v) === i
    );

    return uniques.map((v: string, index: number) => ({
      key: v.replace(/[{}]/g, ""),
      label: `Variável ${v}`,
      example: body.example?.body_text?.[0]?.[index],
    }));
  }

  // 🟣 NAMED → {{name}}
  if (template.parameter_format === "NAMED") {
    return (
      body.example?.body_text_named_params?.map((p: any) => ({
        key: p.param_name,
        label: `Variável {{${p.param_name}}}`,
        example: p.example,
      })) ?? []
    );
  }

  return [];
}

export function buildTemplatePayload({
  to,
  templateName,
  language,
  parameterFormat,
  variables,
}: TemplateSendPayload) {
  const parameters =
    parameterFormat === "POSITIONAL"
      ? Object.values(variables).map(v => ({
          type: "text",
          text: v,
        }))
      : Object.entries(variables).map(([key, value]) => ({
          type: "text",
          text: value,
          parameter_name: key,
        }));

  return {
    messaging_product: "whatsapp",
    to,
    type: "template",
    template: {
      name: templateName,
      language: { code: language },
      components: [
        {
          type: "body",
          parameters,
        },
      ],
    },
  };
}
